import React from "react";
import Footer from "./Footer";
import Profile from "./Profile";
import Feedback from "./Feedback";
import { connect } from "react-redux";
import UserDetail from "./UserDetail";
import Integration from "./Integration";
import AccountAdmin from "./AccountAdmin";
import NewAccordion from "../../NewAccordion";
import { withRouter } from "react-router-dom";
import SidebarIntro from "../layout/SidebarIntro";
import SidebarHeader from "../layout/SidebarHeader";
import { saveProfile } from "../../../actions/profileActions";

const PROFILE_SECTION = [
  {
    icon: "admin_panel_settings",
    label: "Account Admin",
    Section: AccountAdmin,
    collapsable: true,
  },
  {
    icon: "verified_user",
    label: "User Profile",
    Section: Profile,
    collapsable: true,
  },
  {
    icon: "vpn_key",
    label: "Integrations",
    Section: Integration,
    collapsable: true,
  },
  {
    icon: "sms_failed",
    appendIcon: <Feedback />,
    label: "Feedback",
    collapsable: true,
  },
  {
    icon: "emoji_objects",
    label: "Tips & Tricks",
  },
];

const SidebarProfile = ({ onClose, goToCesiumIonPage, goToWebMapServicePage, goToAPIPage }) => (
  <>
    <SidebarHeader onClose={onClose} />
    <SidebarIntro>
      <UserDetail />
    </SidebarIntro>
    <NewAccordion accordions={PROFILE_SECTION} goToCesiumIonPage={goToCesiumIonPage} goToWebMapServicePage={goToWebMapServicePage} goToAPIPage={goToAPIPage} />
    <br />
    <br />
    <br />
    <Footer />
  </>
);

const mapStateToProps = (state) => ({
  loading: state.profile.loading,
  error: state.profile.error,
  profile: state.profile.profile,
});

export default withRouter(
  connect(mapStateToProps, { saveProfile })(SidebarProfile)
);